var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      ref: "headermessage",
      class: ["header-message-" + _vm.headerSettings.style, "h-message"],
      style: _vm.tabletAndAbove ? { top: _vm.scrollValue + "px" } : {}
    },
    [
      _c("resize-observer", { on: { notify: _vm.headerMessageResize } }),
      _vm._v(" "),
      !_vm.mobileBigAndBelow
        ? _c(
            "v-layout",
            { attrs: { "align-center": "" } },
            [
              _c("v-flex", { staticClass: "message-content" }, [
                _vm._v(_vm._s(_vm.$t("Geolocation.Header.Error.Message")))
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "button",
                  {
                    staticClass: "btnX",
                    on: {
                      click: function($event) {
                        return _vm.closeInfo()
                      }
                    }
                  },
                  [_vm._v("X")]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileBigAndBelow
        ? _c("v-layout", { attrs: { "align-center": "" } }, [
            !_vm.isOpenedFromWebView && _vm.mobileBigAndBelow
              ? _c(
                  "div",
                  { staticClass: "content-container" },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "close" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "close",
                            attrs: { flat: "", title: "Close" },
                            on: {
                              click: function($event) {
                                return _vm.closeInfo()
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.userAgent == "ios" || _vm.userAgent == "android"
                      ? [
                          _c(
                            "div",
                            { staticClass: "content-wrapp" },
                            [
                              _c("v-flex", { staticClass: "message-content" }, [
                                _c("p", { staticClass: "paraf" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Header.appInstall.Title"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("Header.appInstall.text"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "message-btn-wrapper",
                                  on: {
                                    click: function($event) {
                                      return _vm.appInstall()
                                    }
                                  }
                                },
                                [
                                  _c("v-btn", { staticClass: "message_btn" }, [
                                    _vm._v(_vm._s(_vm.$t("Get")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "content-wrapp" },
                            [
                              _c("v-flex", { staticClass: "message-content" }, [
                                _c("p", { staticClass: "paraf" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Header.nativeAppBeforeLoginWrongOS"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Header.nativeAppBeforeLogin.Content"
                                      )
                                    )
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ]
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68a060e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68a060e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/HeaderMessages.vue
// module id = null
// module chunks = 